module.exports = __webpack_public_path__ + "img/do.b9eeefef.svg";